import {
  Popover,
  HighlightIcon,
  type IconName,
  type HighlightIconVariant,
} from '@dev-spendesk/grapes';
import type * as NEA from '@spendesk/general-type-helpers/NonEmptyArray';
import React from 'react';

type IconCollection = NEA.NonEmptyArray<{
  name: IconName;
  color: HighlightIconVariant;
}>;

export const defaultIconCollection: IconCollection = [
  { name: 'lightning', color: 'purple' },
  { name: 'building-storefront', color: 'purple' },
  { name: 'plane', color: 'blue' },
  { name: 'truck', color: 'blue' },
  { name: 'buildings-office', color: 'pink' },
  { name: 'fork-knife', color: 'pink' },
  { name: 'shopping-bag', color: 'pink' },
  { name: 'banknote', color: 'pink' },
  { name: 'desktop', color: 'ocean' },
  { name: 'document', color: 'ocean' },
  { name: 'envelope', color: 'ocean' },
  { name: 'wrench', color: 'ocean' },
  { name: 'ticket', color: 'forest' },
  { name: 'face-smile', color: 'forest' },
  { name: 'rocket', color: 'forest' },
  { name: 'megaphone', color: 'forest' },
  { name: 'receipt-percent', color: 'peach' },
  { name: 'dollar-circle-arrow', color: 'peach' },
  { name: 'globe-eu-africa', color: 'lemon' },
  { name: 'car', color: 'lemon' },
];

interface IconPickerProps {
  selectedIcon: IconName;
  selectedColor: HighlightIconVariant;
  onIconChange: (icon: IconName, color: HighlightIconVariant) => void;
  icons?: IconCollection;
}

export const IconPicker: React.FC<IconPickerProps> = ({
  icons = defaultIconCollection,
  selectedIcon,
  selectedColor,
  onIconChange,
}) => {
  return (
    <Popover
      renderTrigger={(triggerProps) => (
        <div {...triggerProps} className="icon-cursor-pointer">
          <HighlightIcon
            name={selectedIcon}
            size={40}
            variant={selectedColor}
          />
        </div>
      )}
    >
      {(closeDropdown) => (
        <div className="body-m grid min-w-[216px] grid-cols-4 gap-4 p-16 text-center">
          {icons.map((icon) => (
            <div
              className="icon-cursor-pointer"
              key={icon.name}
              role="button"
              tabIndex={0}
              onClick={() => {
                onIconChange(icon.name, icon.color);
                closeDropdown();
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  onIconChange(icon.name, icon.color);
                  closeDropdown();
                }
              }}
              aria-label={`Select ${icon.name} icon`}
            >
              <HighlightIcon
                key={icon.name}
                name={icon.name}
                size={40}
                variant={icon.color}
              />
            </div>
          ))}
        </div>
      )}
    </Popover>
  );
};
